import { MenuItem, TextField } from '@mui/material';
import { FeatureInputSupplier } from '../../../../types/advise';

interface ShortlistSupplierPickerProps {
  suppliers: FeatureInputSupplier[];
  value: string;
  onChange: (supplierId: string) => void;
  disabled?: boolean;
}

/** One modal serves every shortlisted supplier, so each picks which supplier its file is for. */
export const ShortlistSupplierPicker = ({ suppliers, value, onChange, disabled }: ShortlistSupplierPickerProps) => (
  <TextField
    select
    disabled={disabled}
    label="Supplier"
    size="small"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    fullWidth>
    {suppliers.map((row) => (
      <MenuItem
        key={row.id}
        value={row.id}>
        {row.supplier_name}
      </MenuItem>
    ))}
  </TextField>
);
